import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router';

import { listPackagesOptions } from '@drivingdoc/api-client/generated/react-query';
import { Package } from 'types/packages';

import { PageContainer } from 'components/PageContainer';

const columns: GridColDef<Package>[] = [
  {
    field: 'name',
    type: 'string',
    headerName: 'Title',
    minWidth: 600,
  },
  {
    field: 'advertise',
    type: 'boolean',
    headerName: 'Enabled',
    minWidth: 150,
  },
  {
    field: 'secure_seat_mode',
    type: 'singleSelect',
    headerName: 'Secure Seat Mode',
    minWidth: 175,
    valueOptions: [
      {
        value: 'at_time_of_enrollment',
        label: 'At Time Of Enrollment',
      },
      {
        value: 'when_deposit_paid',
        label: 'When Deposit Paid',
      },
      {
        value: 'when_full_cost_paid',
        label: 'When Paid In Full',
      },
    ],
  },
];

export function PackageList() {
  const navigate = useNavigate();

  // fetch packages
  const packages = useQuery(listPackagesOptions());
  const packageRows = (packages.data as Package[] | undefined) ?? [];

  return (
    <PageContainer title="Manage Packages">
      <DataGrid
        columns={columns}
        rows={packageRows}
        loading={packages.isPending}
        onRowClick={(params) => navigate(`/admin/packages/${params.row.id}`)}
      />
    </PageContainer>
  );
}

export default PackageList;
